import { render } from "./TaskDetail.vue?vue&type=template&id=c11e149e&scoped=true"
import script from "./TaskDetail.vue?vue&type=script&lang=js"
export * from "./TaskDetail.vue?vue&type=script&lang=js"

import "./TaskDetail.vue?vue&type=style&index=0&id=c11e149e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c11e149e"],['__file',"src/views/h5/crm/project/manage/TaskDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c11e149e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c11e149e', __exports__)) {
    api.reload('c11e149e', __exports__)
  }
  
  module.hot.accept("./TaskDetail.vue?vue&type=template&id=c11e149e&scoped=true", () => {
    api.rerender('c11e149e', render)
  })

}


export default __exports__